import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { locale } from '../../../utils/i18n';
import CONSTANT, { CACHE } from '../../../utils/constants';
import { money, convertRupeeCharToUnicode, getKey, staticPath } from '../../../utils/common';

class ScaleQR extends Component {
  constructor(props) {
    super(props);
    const merchantDetails = this.props.cache.getData(CACHE.PAYMENT_OPTIONS, {}).merchantDetails;
    this.merchantName =
      merchantDetails &&
      (getKey(this.props.cache.getData(CACHE.MERCHANT_CONFIG), 'merchant.name') ||
        getKey(merchantDetails, 'merchantDisplayName') ||
        merchantDetails.merchantName ||
        '');
    this.logo = {
      paytm: `${staticPath()}/assets/images/logo-paytm.svg`,
      upi: `${staticPath()}/assets/images/logo-upi.svg`
    };
  }

  zoomOut = (event, isZoom) => {
    this.props.notify && this.props.notify(event, isZoom);
  };

  render({ qrCode, upiQR }, {}) {
    const txnAmount = convertRupeeCharToUnicode(
      `₹${money(this.props.cache.getData(CONSTANT.TXN_AMOUNT))}`
    );

    return (
      <div
        className="ptm-qr-scale-wrapper"
        onClick={e => this.zoomOut(e, false)}
        data-key="scale-section"
      >
        <div className="ptm-qr-scale-container ptm-body-bg">
          <div className={`ptm-scale-inner`}>
            <div className={`paytm-txt-center ptm-qr-scale-txt1 ptm-semibold ptm-body-color`}>
              {locale('qr.pay')}
            </div>
            <div className={`paytm-txt-center ptm-qr-scale-txt2 ptm-body-color`}>
              {this.merchantName}
            </div>
            <img src={qrCode} className="ptm-qr-scaled-img" data-key="scale-qr" />
            <div className={`ptm-scale-amount ptm-body-color`}>{txnAmount}</div>
          </div>
          <div
            className={`ptm-qr-type ptm-scale-qr-type ptm-pos-r paytm-txt-center ptm-body-color`}
          >
            {upiQR ? locale('qr.scan.qrcode.upi') : locale('qr.scan.qrcode')}
            <div className={`ptm-qr-logo paytm-txt-center ptm-qr-scale-logo`}>
              <img src={this.logo.paytm} data-key="qr-paytm" />
              {upiQR ? <span className={`ptm-qr-pipe`}> | </span> : ''}
              {upiQR && <img src={this.logo.upi} data-key="qr-upi" />}
            </div>
          </div>

          <div className="ptm-close-wrap ptm-qr-scale-close" onClick={e => this.zoomOut(e, false)}>
            <span className="ptm-cross" />
          </div>
        </div>
      </div>
    );
  }
}

export default connect('cache')(ScaleQR);



// WEBPACK FOOTER //
// ./components/qr/scale/index.js